import { useState, useEffect, useCallback } from 'react';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ライト・ダークのテーマ種別を定義する
 * @graph-connects none
 */
export type Theme = 'light' | 'dark';

/** @graph-connects none */
function getInitialTheme(): Theme {
  const stored = localStorage.getItem('ux-mirror-theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ダークモード切替フック。data-theme属性とlocalStorage永続化でテーマを管理
 * @graph-connects none
 */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('ux-mirror-theme', theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggleTheme };
}
